import { render } from "./DragDropInput.vue?vue&type=template&id=3fd9e1d8&scoped=true"
import script from "./DragDropInput.vue?vue&type=script&lang=js"
export * from "./DragDropInput.vue?vue&type=script&lang=js"

import "./DragDropInput.vue?vue&type=style&index=0&id=3fd9e1d8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd9e1d8"]])

export default __exports__